export const getMappedArray = <ArrayType extends Record<string, any>>(
  array: ArrayType[],
  propertyKey: keyof ArrayType
): Record<string, ArrayType> => {
  return array.reduce<Record<string, ArrayType>>((map, item) => {
    const mapKey = item[propertyKey]

    map[mapKey] = item

    return map
  }, {})
}
